import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

export default function useLanguageRegionCode(): LanguageRegionCode {
  return global.__AT_DATA__.languageRegionCode;
}
